<div class="container section">
  <h2 class="section-title">{{ tabTitle }}</h2>
</div>

<div class="container">
  <div class="tabgroup">
    <mat-tab-group>
      @for (item of tabs; track item; let i = $index) {
        <mat-tab   label="{{ item?.title }}">
          <div class="product-description-section">
            <div class="tab-contents-image">
              <img [ngStyle]="{'margin': item.imagestyle}" src="{{imageBasePath+item?.image}}" />
            </div>
            <div class="tab-contents">
              <h4 class="tab-contents-title">{{ item?.title }}</h4>
              @for (info of item.claimInfo; track info) {
                <div>
                  <p class="tab-contents-text">{{ info.text }}</p>
                </div>
              }
            </div>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>

  <div class="disclaimer">
    <p><b>Note:</b> {{ disclaimer }}</p>
  </div>
</div>
